/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-secondary': {
    width: 5,
    height: 8,
    viewBox: '0 0 5 8',
    data: '<path pid="0" d="M2.1 6.375c.8 0 1.2-.32 1.2-.96 0-.334-.177-.58-.53-.74a3.953 3.953 0 0 0-.725-.26 5.813 5.813 0 0 1-.74-.245 2.974 2.974 0 0 1-.595-.345C.316 3.53.12 3.08.12 2.47S.33 1.38.755 1.03c.423-.35.976-.525 1.66-.525.683 0 1.318.136 1.905.41v1.5l-1.02.07v-.58c0-.1-.014-.174-.04-.22-.074-.127-.309-.19-.705-.19-.397 0-.69.07-.88.21-.19.14-.285.356-.285.65 0 .213.08.4.24.56.106.106.265.195.475.265.21.07.433.141.67.215.236.073.446.153.63.24.183.086.375.206.575.36.406.3.61.763.61 1.39 0 .626-.225 1.12-.675 1.48-.45.36-1.044.54-1.78.54-.737 0-1.399-.137-1.985-.41v-1.58l1.02-.07v.61c0 .1.013.173.04.22.026.046.108.091.245.135.136.043.351.065.645.065z" fill-rule="nonzero"/>'
  }
})
